import React from "react";
import { Location } from "../Location";
import { SnapshotForm } from "@contracts/CustomerContractProfile/components/SnapshotsTable/form/SnapshotForm";

interface Params {
  contractId: string;
  snapshotId: string;
  action: string;
}

export class CustomerContractSnapshotEditorLocation extends Location<Params> {
  constructor(contractId: string, snapshotId: string, action: string) {
    super({ snapshotId, contractId, action });
  }

  render(): React.ReactElement<any> {
    return (
      <SnapshotForm
        snapshotId={this.params.snapshotId}
        contractId={this.params.contractId}
        action={this.params.action}
      />
    );
  }

  toURI() {
    const { snapshotId, contractId } = this.params;
    return `/customer_contract/${contractId}/snapshot/${snapshotId || "new"} `;
  }
}
